import { Modal, Spin } from 'antd'
import { DATE_TIME_DISPLAY, DEFAULT_PAGE } from 'configs/constant'
import dayjs from 'dayjs'
import useInview from 'hooks/useInview'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { apiGetNotification } from 'services/notifyService'
import styles from './Notification.module.scss'
import { useAppSelector } from 'hooks'
import './NotificationModal.scss'
import { OS_TYPE } from 'models/common'

const Notification = ({ isOpenModal, setOpenModal }: any) => {
  const [listNotify, setListNotify] = useState<any[]>([])
  const [page, setPage] = useState(DEFAULT_PAGE)
  const [total, setTotal] = useState(0)
  const { ref, inView } = useInview()
  const { t } = useTranslation()
  const { app_id } = useAppSelector((state) => state.app)
  const [loading, isLoading] = useState(true)

  const getNotification = async () => {
    try {
      const notify = await apiGetNotification({
        page: page,
        per_page: 11,
        app_id: app_id,
        os_type: OS_TYPE.WEB
      })
      setTotal(notify.total)
      setListNotify([...listNotify, ...notify.list])
      isLoading(false)
    } catch (error) {
      console.log('errorNotify', error)
    }
  }

  useEffect(() => {
    if (inView && listNotify.length < total) {
      setPage((page) => page + 1)
    }
  }, [inView])

  useEffect(() => {
    getNotification()
  }, [page])
  return (
    <Modal
      className="modal-common notification-modal"
      title="お知らせ"
      centered
      open={isOpenModal}
      width={860}
      bodyStyle={{
        maxHeight: '78vh',
        overflow: 'auto'
      }}
      footer={null}
      onCancel={() => setOpenModal(false)}
    >
      <div className={styles.container}>
        {loading ? (
          <div style={{ textAlign: 'center' }}>
            <Spin />
          </div>
        ) : listNotify.length === 0 ? (
          <p style={{ textAlign: 'center' }}>{t('nodata_notify')}</p>
        ) : (
          listNotify.map((noti) => (
            <div className={styles.wrap} key={noti.id}>
              <span className={styles.content}>{noti.content}</span>
              <span className={styles.dateTime}>{dayjs(noti.schedule_at).format(DATE_TIME_DISPLAY)}</span>
            </div>
          ))
        )}
        <div ref={ref} style={{ height: '1rem' }} />
      </div>
    </Modal>
  )
}

export default Notification
